(function () {
    Date.today = function() {
        const dtToday = new Date();
        dtToday.setHours(0, 0, 0, 0);

        return dtToday;
    }

    Date.isLessOrEqualTimeOfDay = function (hours, minutes, hoursToCompareTo, minutesToCompareTo) {
        return hours < hoursToCompareTo || (hours === hoursToCompareTo && minutes <= minutesToCompareTo);
    }

    Date.isSameDateIgnoringTime = function(date1, date2) {
        return new Date(date1).toDateString() === new Date(date2).toDateString();
    }

    Date.diffHours = function(date1, date2) {
        const fromDate = parseInt(new Date(date1).getTime() / 1000);
        const toDate = parseInt(new Date(date2).getTime() / 1000);
        return (toDate - fromDate) / 3600;  //returns difference in hrs
    }

    Date.diffDays = function(date1, date2) {
        return Date.diffHours(date1, date2) / 24;
    }

    /*
     * Parses date from Week number string representation of form: %weekNumber%-%fullYear%.
     */
    Date.parseFromWeekNumber = function (yearWeekNumberString) {

        if (!yearWeekNumberString) throw new Error('yearWeekNumberString must be defined.');

        const year = yearWeekNumberString.substring(yearWeekNumberString.indexOf('-') + 1);
        const week = yearWeekNumberString.substring(0, yearWeekNumberString.indexOf('-'));


        // Jan 1 of 'year'
        const d = new Date(year, 0, 1);
        const offset = d.getTimezoneOffset();

        // ISO: week 1 is the one with the year's first Thursday 
        // so nearest Thursday: current date + 4 - current day number
        // Sunday is converted from 0 to 7
        d.setDate(d.getDate() + 4 - (d.getDay() || 7));

        // 7 days * (week - overlapping first week)
        d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000
            * (week + (year == d.getFullYear() ? -1 : 0)));

        // daylight savings fix
        d.setTime(d.getTime()
            + (d.getTimezoneOffset() - offset) * 60 * 1000);

        // back to Monday (from Thursday)
        d.setDate(d.getDate() - 3);

        return d;
    }

    Date.prototype.toLocaleShortDateString = function() {
        const options = { year: '2-digit', month: '2-digit', day: '2-digit' };
        const d = this;

        return d.toLocaleDateString(undefined, options);
    }

    Date.prototype.getYearWeekNumber = function() {
        const currentDate = this;
        const januaryFirst = new Date(currentDate.getFullYear(), 0, 1);
        const daysToNextMonday = (januaryFirst.getDay() === 1) ? 0 : (7 - januaryFirst.getDay()) % 7;
        const nextMonday = new Date(currentDate.getFullYear(), 0, januaryFirst.getDate() + daysToNextMonday);

        return (currentDate < nextMonday) ? 52 : (currentDate > nextMonday ? Math.ceil((currentDate - nextMonday) / (24 * 3600 * 1000) / 7) : 1);
    }

    Date.prototype.setToMonday = function () {
        const d = new Date(this);
        const day = d.getDay();
        const diff = d.getDate() - day + (day === 0 ? -6 : 1); // adjust when day is sunday

        d.setDate(diff);
        d.setHours(1);
        d.setMinutes(0);
        d.setSeconds(0);

        return new Date(d);
    }

    Date.prototype.toISOStringUTC = function(){
        const d = this;

        function pad(number) {
            return number < 10 ? "0" + number : number;
        }

        const isoStringUtc = d.getUTCFullYear() +
            '-' + pad(d.getUTCMonth() + 1) +
            '-' + pad(d.getUTCDate()) +
            'T' + pad(d.getUTCHours()) +
            ':' + pad(d.getUTCMinutes()) +
            ':' + pad(d.getUTCSeconds());

        return isoStringUtc.toString();
    }

    Date.prototype.addHours = function (h) {
        const copiedDate = new Date(this.getTime());
        copiedDate.setHours(copiedDate.getHours() + h);
        return copiedDate;
    }

    Date.prototype.addDays = function(d) {
        const copiedDate = new Date(this);
        copiedDate.setDate(copiedDate.getDate() + d);
        return copiedDate;
    }

    Date.isLeapYear = function (year) {
        return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
    };

    Date.getDaysInMonth = function (year, month) {
        return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    };

    Date.prototype.isLeapYear = function () {
        return Date.isLeapYear(this.getFullYear());
    };

    Date.prototype.getDaysInMonth = function () {
        return Date.getDaysInMonth(this.getFullYear(), this.getMonth());
    };

    Date.prototype.addMonths = function (value) {
        const copiedDate = new Date(this);

        var yearsToAdd = Math.trunc(value / 12);
        var monthsToAdd = Math.abs(value) >= 12 ? value % 12 : value;

        var n = copiedDate.getDate();
        copiedDate.setDate(1);
        if (monthsToAdd !== 0) {
            copiedDate.setMonth(copiedDate.getMonth() + monthsToAdd);
        }
        if (yearsToAdd !== 0) {
            copiedDate.setFullYear(copiedDate.getFullYear() + yearsToAdd);
        }

        copiedDate.setDate(Math.min(n, copiedDate.getDaysInMonth()));
        return copiedDate;
    };

    Date.prototype.isHoliday = function(holidays) {
        const d = this;

        //See if the current date is a weekend or not
        if (d.getDay() === 0 || d.getDay() === 6) {
            return true; //weekend
        }

        //Then see if we were given a holidays list and if the date is in it, meaning it's a holiday
        if (holidays && holidays.length > 0) {
            for (let i = 0; i < holidays.length; i++) {
                if (holidays[i].getDate() === d.getDate() && holidays[i].getMonth() === d.getMonth() && holidays[i].getYear() === d.getYear()) {
                    return true;
                }
            }
        }
        return false;
    }

    Date.prototype.addHoursSkippingNonWorkingDays = function(h, holidays) {
        const copiedDate = new Date(this.getTime());
        var hoursToAdd = h;

        while (hoursToAdd > 0) {
            const addValue = hoursToAdd > 24 ? 24 : hoursToAdd;

            copiedDate.setHours(copiedDate.getHours() + addValue);

            if (!copiedDate.isHoliday(holidays)) {
                hoursToAdd -= addValue;
            }
        }

        return copiedDate;
    }
})();
